import { setErrorHandler } from '@stencil/core';
import { rollbar } from '../utils/rollbar';
const errorHandler = (error, failedElement) => {
  rollbar.error(error, {
    failedElement,
  });
};
setErrorHandler(errorHandler);

export default function() {}
